import SendManager from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    sendManagers: [],
    filteredCollection: [],
  },
  getters: {
    getCollection: state => state.sendManagers,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.sendManagers.find(sendManager => sendManager.id === id),
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/sendManager',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((sendManager) => {
            commit('addSendManagerToCollection', { sendManagerData: sendManager })
            return getters.getById(sendManager.id)
          })

          commit('addSendManagerToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    sync({ commit, getters, state }) {
      return this.dispatch('get', {
        path: 'v1/sendManager/sync'
      }).then((res) => {

        return res
      })
    }
  },
  mutations: {
    addSendManagerToCollection(state, { sendManagerData, opts }) {
      addToCollection(this, state.sendManagers, sendManagerData, SendManager, opts)
    },
    addSendManagerToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeSendManagerFromCollection(state, sendManagerId) {
      const index = state.sendManagers.findIndex(el => el.id === sendManagerId)

      if (index === -1) {
        console.warn(`Could not find/delete sendManager ${sendManagerId}`)
        return
      }

      state.sendManagers.splice(index, 1)
    },
    clearCollection(state) {
      state.sendManagers = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/sendManager/store.js